module.exports = __webpack_public_path__ + "img/emilp1.ff4ab3f8.png";